import LoyaltyPointsForm from './component';

export default LoyaltyPointsForm;
